import { render, staticRenderFns } from "./DashboardDater.vue?vue&type=template&id=308a1118&"
import script from "./DashboardDater.vue?vue&type=script&lang=js&"
export * from "./DashboardDater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports